import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { IconButton } from "@mui/material";
import { MoreVert } from "@mui/icons-material";
import { useSelector } from "react-redux";
import haveAccess from "../../utilities/functions/haveAccess";
import VisibilityIcon from "../../assets/images/icons/Google SVGs/visibility.svg";
import { ReactComponent as EditIcon } from "../../assets/images/icons/Google SVGs/edit.svg";
import doctorIcon from "./../../assets/images/icons/doctor.svg";

const DoctorCard = (props) => {
  const navigate = useNavigate();
  const { roles } = useSelector((state) => state.user);

  return (
    <div>
      <div
        className="card border-1 border-bootstrap-gray-300 background-bootstrap-gray-100 border-radius-8"
        type="button"
      >
        <div className="card-body p-2 d-flex flex-row">
          {props.doctor.file ? (
            <img
              className="doctor-image-box col col-auto object-fit-cover me-2"
              src={props.doctor.file}
            />
          ) : (
            <img
              className="doctor-image-box col col-auto object-fit-cover rounded-pill p-2 background-bootstrap-gray-200 me-2"
              src={doctorIcon}
            />
          )}
          <div className="col d-flex flex-column">
            <div
              className="text-decoration-none"
              type="button"
              onClick={() => {
                navigate(
                  `/doctor?${"dr=" + props.doctor.id}${
                    props.department ? "&dep=" + props.department : ""
                  }${props.place ? "&pl=" + props.place : ""}`
                );
              }}
              // href={`/doctor?${"dr=" + props.doctor.id}${
              //   props.department ? "&dep=" + props.department : ""
              // }${props.place ? "&pl=" + props.place : ""}`}
            >
              <span className="mt-0 mb-auto fs-14 fw-bold color-bootstrap-gray-800">
                {props.doctor.title} {props.doctor.first_name}{" "}
                {props.doctor.last_name}
              </span>
            </div>

            <span className="my-0 fs-12 fw-normal color-bootstrap-gray-600">
              {props.doctor.last_degree}
            </span>
          </div>
          {haveAccess(roles, "doctor_card_setting") && (
            <div className="col-auto d-flex align-items-center color-bootstrap-gray-700">
              <div className="dropdown me-1">
                <IconButton
                  type="button"
                  id="dropdownMenuOffset"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  data-bs-offset="30,-45"
                  // onClick={handleClick}
                >
                  <MoreVert />
                </IconButton>

                <ul
                  className="fit-dropdown dropdown-menu ul-drop-shadow border-radius w-fit align-items-center"
                  aria-labelledby="dropdownMenuOffset"
                >
                  {haveAccess(roles, "doctor_card_show") && (
                    <li
                      className="dropdown-item px-2"
                      type="button"
                      onClick={() => {
                        navigate(
                          `/doctor?${"dr=" + props.doctor.id}${
                            props.department ? "&dep=" + props.department : ""
                          }${props.place ? "&pl=" + props.place : ""}`
                        );
                      }}
                    >
                      <div className="color-bootstrap-gray-600 text-decoration-none fs-12 w-100 d-flex align-items-center">
                        <img src={VisibilityIcon} className="me-1" alt="" />
                        مشاهده
                      </div>
                    </li>
                  )}
                  {haveAccess(roles, "doctor_edit") && (
                    <li
                      className="dropdown-item px-2"
                      type="button"
                      onClick={() => {
                        // handleClose();
                        window.scrollTo(0, 0);
                        navigate(`/doctor-store?${"dr=" + props.doctor.id}`);
                      }}
                    >
                      <div className="color-bootstrap-gray-600 text-decoration-none fs-12 w-100 d-flex align-items-center">
                      <EditIcon width={16}
                          className="me-1"/>

                        ویرایش
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default DoctorCard;
